import React from 'react';
import { Select, Typography } from 'antd';
import { IBestDataset } from '../../../../../types/analytics';
import styles from '../../../Analytics/components/Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface ReportsPreprocessedInputFormProps {
  datasets: IBestDataset[];
  datasetSW: string;
  datasetHD: string;
  datasetWind: string;
  isLoadingDatasetSW: boolean;
  isLoadingDatasetHD: boolean;
  isLoadingDatasetWind: boolean;
  onSelectDataset: (type: 'SW' | 'HD' | 'Wind') => (value: string) => void;
}

export default function ReportsPreprocessedInputForm({
  datasets,
  datasetSW,
  datasetHD,
  datasetWind,
  onSelectDataset,
  isLoadingDatasetHD,
  isLoadingDatasetSW,
  isLoadingDatasetWind,
}: ReportsPreprocessedInputFormProps) {
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Waves</Text>
        <Select
          id='Preprocessed-Dataset_Waves_Input'
          value={datasetSW || '-'}
          onChange={onSelectDataset('SW')}
          placeholder='Select dataset'
          disabled={isLoadingDatasetSW}
        >
          <Select.Option value='none'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Waves')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Ocean</Text>
        <Select
          id='Preprocessed-Dataset_Ocean_Input'
          value={datasetHD || '-'}
          onChange={onSelectDataset('HD')}
          placeholder='Select dataset'
          disabled={isLoadingDatasetHD}
        >
          <Select.Option value='none'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Ocean')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Atmosphere</Text>
        <Select
          id='Preprocessed-Dataset_Atmosphere_Input'
          value={datasetWind || '-'}
          onChange={onSelectDataset('Wind')}
          placeholder='Select dataset'
          disabled={isLoadingDatasetWind}
        >
          <Select.Option value='none'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Atmosphere')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
      </div>
    </div>
  );
}
